<form name="form" [formGroup]="form">
  <div class="row gx-3 gy-md-3 gy-sm-3 gy-xs-2 gy-2">
    <div class="col-md-6">
      <div class="group__input">
        <input
          aria-label="State3"
          formControlName="destino"
          (keyup)="autoComplete($event)"
          (keypress)="inputValidator.removeNonValid($event, inputValidator.VALID_NAME)"
          placeholder="¿A que país le gustaría ir?"
          (click)="autoCompleteInit()"
        />
        <img src="./assets/svg/location-red.svg" alt="o" />
      </div>
    </div>
    <div class="col-md-6">
      <div class="group__input">
        <select formControlName="themes" [class.first-option]="form.controls.themes.value === ''">
          <option value="" disabled selected hidden>Seleccionar tema</option>
          <option *ngFor="let elem of themes" [value]="elem.code">
            {{ elem.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-6">
      <div class="group__input">
        <select formControlName="months" [class.first-option]="form.controls.months.value === ''">
          <option value="" disabled selected hidden>Seleccionar mes</option>
          <option *ngFor="let elem of months" [value]="elem.code">
            {{ elem.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-6">
      <div class="row gx-3 gy-3 d-flex align-items-center">
        <div class="col-12 col-md">
          <div class="group__input">
            <select
              formControlName="noches"
              [class.first-option]="form.controls.noches.value === ''"
            >
              <option value="" disabled selected hidden>Seleccionar número de noches</option>
              <option *ngFor="let elem of noches" [value]="elem.code">
                {{ elem.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col col-md-auto">
          <app-button
            (buttonClick)="searchPaquete()"
            [isFullWidth]="true"
            buttonClass="px-4"
            title="Buscar"
          >
            <i aria-label="Buscar" class="custom-icon icon-search"></i>
            <span class="d-md-none ms-2">Buscar</span>
          </app-button>
        </div>
      </div>
    </div>
  </div>
</form>
